'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _store = require('linksoft/core/store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var common = {
    createElement: function createElement(tagName, parentElement, params) {
        // Create element helper, to simplify this process
        if (!tagName || !parentElement) return null;

        var element = document.createElement(tagName);
        if (params) {
            (0, _assign2.default)(element, params);
        }
        parentElement.appendChild(element);
        return element;
    },
    getCartData: function getCartData() {
        try {
            var storeData = _store2.default.get();
            return storeData.getState().cart;
        } catch (e) {
            console.error('Cart state was not loaded.', e);
            return null;
        }
    },
    sortByStringParam: function sortByStringParam(array, paramName) {
        var collator = Intl.Collator();

        return array.sort(function (a, b) {
            return collator.compare(a[paramName], b[paramName]);
        });
    },
    replaceDiacriticsCharacters: function replaceDiacriticsCharacters(inputString) {
        var diacriticsChars = "áäčďéěíĺľňóôőöŕšťúůűüýřžÁÄČĎÉĚÍĹĽŇÓÔŐÖŔŠŤÚŮŰÜÝŘŽ";
        var replacements = "aacdeeillnoooorstuuuuyrzAACDEEILLNOOOORSTUUUUYRZ";
        var result = '';
        for (var p = 0; p < inputString.length; p++) {
            var currentChar = inputString.charAt(p);
            var charIndex = diacriticsChars.indexOf(currentChar);
            result += charIndex !== -1 ? replacements.charAt(charIndex) : currentChar;
        }
        return result;
    }
};

exports.default = common;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/modules/Common.js
// module id = 641
// module chunks = 0